import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { cn } from '~/utils';
type ModalContentProps = {
  className?: string;
  children: ReactNode;
};
export default function ModalContent(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("min-h-0 flex-1 overflow-y-auto px-6 py-6 sm:px-10", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <main className={t1}>{children}</main>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}